import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        /* UAE Theme Premium Variants */
        uaeRed:
          "bg-uae-red text-uae-white shadow-lg hover:shadow-glow-red hover:bg-uae-red/90 font-semibold",
        uaeGreen:
          "bg-uae-green text-uae-white shadow-lg hover:shadow-glow-green hover:bg-uae-green/90 font-semibold",
        whatsapp:
          "bg-[#25D366] text-uae-white shadow-lg hover:bg-[#20BD5A] font-semibold",
        premium:
          "bg-gradient-to-r from-uae-red to-uae-green text-uae-white shadow-premium hover:shadow-2xl font-semibold",
        outlinePremium:
          "border-2 border-uae-red bg-transparent text-uae-red hover:bg-uae-red hover:text-uae-white font-semibold",
        outlineGreen:
          "border-2 border-uae-green bg-transparent text-uae-green hover:bg-uae-green hover:text-uae-white font-semibold",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-9 rounded-md px-4 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        xl: "h-14 rounded-lg px-10 text-lg",
        icon: "h-10 w-10",
        iconLg: "h-14 w-14",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
